// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var HhsGenderIdentity;
(function (HhsGenderIdentity) {
    HhsGenderIdentity["Male"] = "M";
    HhsGenderIdentity["Female"] = "F";
    HhsGenderIdentity["FTM"] = "FTM";
    HhsGenderIdentity["MTF"] = "MTF";
    HhsGenderIdentity["NonConforming"] = "GNC";
    HhsGenderIdentity["Unknown"] = "U";
})(HhsGenderIdentity || (HhsGenderIdentity = {}));
//# sourceMappingURL=hhsGenderIdentity.js.map